import { render, staticRenderFns } from "./DropMenuContent.vue?vue&type=template&id=230009d4&scoped=true&"
import script from "./DropMenuContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DropMenuContent.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DropMenuContent.vue?vue&type=style&index=0&id=230009d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230009d4",
  null
  
)

export default component.exports